import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent6: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">Create life-cycle use case</h3>
            <span className="fs-7 text-muted">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Create life-cycle use case
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  In this step you will describe in detail how your persona determines they have a problem that can be solved (or they now realize there is an opportunity to solve it), finds out about your product, acquires it, uses it, gets value from it, pays for it, and buys more and/or tells others about it.

This is a first pass at defining the process of the customer before they get your product or service, and uses it; but we want you to start thinking about this now. It will be refined as you go on in the process. You will gain additional clarity and alignment throughout your team by detailing the various aspects of the full life cycle use case and further focusing the discussion on what specifically your product will do for your customer… and what your customer will do with it.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Map out the full life cycle use case
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  Rather than simply describing how your persona will use your product, also detail how the end user determines they have a need for your product, how they acquire your product and, ultimately, how you will get paid for your product. You will start by mapping out the process from beginning to end for your persona and then check to see if it is consistent with other potential customers as well. The easiest way to start is by mapping out how your persona uses the product once it is acquired. From there, map out the acquisition and post-acquisition support cases, and make sure you end up with clear diagrams or drawings for all of the following.

                  How will users:

                  Determine they have a need/opportunity to do something different, in the first place?
                  Find out about your product?
                  Analyze your product?
                  Acquire your product?
                  Install your product?
                  Use your product in detail?
                  Determine the value gained from your product?
                  Pay for your product?
                  Receive support for your product?
                  Buy more product?
                  Spread awareness (hopefully positive) about your product?
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>

  );
};

export { StepContent6 };
